import http from '@/api/http'
import { assertCourierApi, courierRequest } from '@/entities/courier/api/courierRequest'
import { mapCourierOrder, mapCourierOrderList } from '@/entities/order/model/mapCourierOrder'

function mapActiveOrderIds(raw) {
  if (!Array.isArray(raw)) {
    return []
  }
  return raw.map((id) => String(id)).filter(Boolean)
}

function mapMutationResult(body) {
  return {
    order: mapCourierOrder(body?.data),
    activeOrderIds: mapActiveOrderIds(body?.active_order_ids),
  }
}

export async function fetchCourierOrderByIdApi(orderId) {
  if (!orderId) {
    return null
  }

  assertCourierApi()
  const body = await courierRequest(() => http.get(`/courier/order/${orderId}`))
  return mapCourierOrder(body?.data)
}

export async function fetchCourierActiveOrdersApi() {
  assertCourierApi()
  const body = await courierRequest(() => http.get('/courier/orders'))
  const items = mapCourierOrderList(body?.data ?? [])
  return {
    items,
    total: Number(body?.total) || items.length,
    activeOrderIds: mapActiveOrderIds(body?.active_order_ids),
  }
}

export async function fetchCourierCompletedOrdersApi() {
  assertCourierApi()
  const body = await courierRequest(() => http.get('/courier/history'))
  return mapCourierOrderList(body?.data ?? [])
}

export async function acceptCourierOrderApi(orderId) {
  if (!orderId) {
    return null
  }

  assertCourierApi()
  const body = await courierRequest(() =>
    http.post(`/courier/order/${orderId}/accept`, {}),
  )
  return mapMutationResult(body)
}

export async function rejectCourierOrderApi(orderId) {
  if (!orderId) {
    return { order: null, activeOrderIds: [] }
  }

  assertCourierApi()
  const body = await courierRequest(() => http.post(`/courier/order/${orderId}/reject`, {}))
  return mapMutationResult(body)
}

export async function markCourierOrderPickedUpApi(orderId) {
  if (!orderId) {
    return null
  }

  assertCourierApi()
  const body = await courierRequest(() =>
    http.post(`/courier/order/${orderId}/picked-up`, {}),
  )
  return mapMutationResult(body)
}

export async function markCourierOrderDeliveredApi(orderId, { paymentReceived } = {}) {
  if (!orderId) {
    return { order: null, activeOrderIds: [] }
  }

  assertCourierApi()
  const payload = {}
  if (paymentReceived) {
    payload.payment_received = true
  }
  const body = await courierRequest(() =>
    http.post(`/courier/order/${orderId}/delivered`, payload),
  )
  return mapMutationResult(body)
}
